
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import SkeletonItem from '@xt/www/components/skeleton/item.vue'

@Observer
@Component({
  components: {
    SkeletonItem
  }
})
export default class ItemSkeleton extends Vue {
  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
